import { NotificationDto } from '@gap/backend/app-services/notification/models/NotificationDto';
import Box from '@mui/material/Box';
import ListItem from '@mui/material/ListItem';
import ListItemAvatar from '@mui/material/ListItemAvatar';
import ListItemText from '@mui/material/ListItemText';
import Typography from '@mui/material/Typography';
import { observer } from 'mobx-react-lite';
import { useNotificationsStore } from './NotificationsStore';
import NotificationDialog from './NotificationDialog';
import NotificationStore from './NotificationStore';
import useStore from 'reusable/mobx-store-utils';
import AvatarWithName from 'reusable/mui/avatar-with-name/AvatarWithName';
import { themeConfig }from '@gap/shared/theme';
import Badge from '@mui/material/Badge';
import SkeletonLoadingBox from 'reusable/mui/skeleton/SkeletonLoadingBox';
import Avatar from '@mui/material/Avatar';
import Storefront from '@mui/icons-material/StorefrontOutlined';
import GapIcon from '/images/The_Gap_Icon.svg'
import variables from 'variables/variables'

export default observer(
   function Notification({ notification }: { notification: NotificationDto }) {
      const notificationsStore = useNotificationsStore()
      const notificationStore = useStore(sp => new NotificationStore(sp), { notification, notificationsStore })

      if (notificationStore.loader.isLoading) {
         return <SkeletonLoadingBox sx={{ height: '100px', ml: 1 }} isLoading={true} />
      }

      return <ListItem sx={{ py: 2, pl: 2, cursor: 'pointer' }}
         alignItems="flex-start" onClick={notificationStore.onNotificationClick}>
         <ListItemAvatar>
            {notification.type === 'client' && <Avatar sx={{ bgcolor: themeConfig.primary[400] }}><Storefront /></Avatar>}
            {notification.type === 'system' && <Avatar sx={{ bgcolor: themeConfig.primary[200] }}><img src={GapIcon} width="28" height="28" alt={variables.gapName} /></Avatar>}
            {(notification.type === 'user' || !notification.type) && <AvatarWithName typographySx={{ fontSize: '20px' }} name={notification.notifiedBy} />}
         </ListItemAvatar>
         <ListItemText
            disableTypography
            sx={{ whiteSpace: 'unset!important' }}
            primary={<Box>
               <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                  <Typography variant="body1" sx={{ color: themeConfig.primary[900] }}>
                     {notification.title}
                  </Typography>
                  {!notification.read && (
                     <Badge
                        variant="dot"
                        sx={{
                           mr: 1,
                           "& .MuiBadge-dot": {
                              backgroundColor: themeConfig.passion
                           }
                        }}
                     />
                  )}
               </Box>
               <Typography variant="caption" sx={{ color: themeConfig.primary[600] }}>
                  {notificationStore.notificationDate}
               </Typography>
            </Box>}
            secondary={<Box sx={{ mt: 1 }}>
               <Typography variant="body2" sx={{ color: themeConfig.primary[900] }}>
                  {notification.content}
               </Typography>
               {notification.action?.dialog && <NotificationDialog />}
            </Box>}
         />
      </ListItem>
   }
)
